import { motion } from "framer-motion"

import { fadeUp } from "./marketing-motion"
import { SalesLinkClaim } from "./SalesLinkClaim"

export function FooterCta() {
  return (
    <section className="relative overflow-hidden bg-primary px-4 py-24 sm:px-6 sm:py-32 lg:py-36">
      <div
        className="pointer-events-none absolute -left-20 top-30 size-80 rounded-full bg-secondary/30 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -right-16 bottom-20 size-96 rounded-full bg-[#be9afc]/20 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute left-[12%] top-30 size-8 rounded-full bg-[#be9afc]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute right-[18%] bottom-20 size-10 rounded-full bg-[#be9afc]"
        aria-hidden
      />
      <motion.div {...fadeUp} className="relative mx-auto max-w-[96%] text-center lg:max-w-[80%]">
        <h2 className="font-display mx-auto max-w-4xl text-4xl leading-[0.92] text-primary-foreground sm:text-5xl md:text-6xl lg:text-[4rem]">
        Ready when you are
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-base font-semibold text-primary-foreground/90 xl:text-lg">
        Start free, share your link, and give your customers a real place to browse and buy.
        </p>
        <div className="mt-10 flex justify-center">
          <SalesLinkClaim onDark animate={false} />
        </div>
      </motion.div>
    </section>
  )
}
